import apiClient from './config.js';

export default {
  // iniciar sesión de usuario
  async login(email, password) {
    const params = new FormData();
    params.append('username', email);
    params.append('password', password);
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        'Content-Type': 'multipart/form-data'
      }, ...config.headers };
      return config;
    });
    return apiClient.post('auth/login', params);
  },
  // Borrar las credenciales del usuario
  logout() {
    return apiClient.post('logout');
  },
  // iniciar sesión de usuario
  async changePassword(password, newPassword) {
    const data = {
      password,
      new_password: newPassword,
      email: localStorage.getItem('email')
    }
    return apiClient.post('auth/change_password', data);
  },
  async getUserEmails(token) {
    apiClient.interceptors.request.use((config) => {
      config.headers = { ...{ 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }, ...config.headers };
      return config;
    });
    return await apiClient.get('auth/user_emails');
  },
};
